import basePath from './basePath'

const Day6 = () => import(/* webpackChunkName: "group-day6" */ '@/components/day6/day6')
const Day6Main = () => import(/* webpackChunkName: "group-day6" */ '@/components/day6/day6-main')
const Day6MailingList = () => import(/* webpackChunkName: "group-day6" */ '@/components/day6/day6-mailing-list')

export default [
  {
    path: `/${basePath.day6}`,
    component: Day6,

    children: [
      {
        path: '',
        name: 'day6-main',
        component: Day6Main,
        meta: {
          returnAfterAuth: true
        }
      },
      {
        path: 'open',
        component: Day6Main
      },
      {
        path: 'open/:id',
        alias: 'o/:id',
        name: 'day6-open',
        component: Day6Main,
        props: true
      }
    ]
  },
  {
    path: '/character-mailing-list',
    name: 'character-mailing-list',
    component: Day6MailingList
  }
]
